// React
import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, ButtonCell, Cell, Chip, List, Multiselectable, Select, Section } from '@telegram-apps/telegram-ui';

// AntD Mobile
import { Picker } from 'antd-mobile'

// Icons
import { ReactComponent as AddIcon } from "../assets/add.svg";
import { ReactComponent as ForceIcon } from "../assets/force.svg";
import { ReactComponent as MediaIcon } from "../assets/media.svg";
import { ReactComponent as OriginalIcon } from "../assets/original.svg";
import { ReactComponent as SourceIcon } from "../assets/source.svg";
import { ReactComponent as CancelIcon } from "../assets/cancel.svg";

const tg = window.Telegram.WebApp;

const TimersPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [timers, setTimers] = useState(stream.timer);
    const [timezoneTimers, setTimeZoneTimers] = useState([]);
    const [days, setDays] = useState(stream.days);
    const [timezone, setTimezone] = useState(stream.shift ?? 0);
    const [timeVisible, setTimeVisible] = useState(false);

    const timeZones = [
        { gmt: "GMT-12 (Бейкер)", shift: -15 },
        { gmt: "GMT-11 (Паго-Паго)", shift: -14 },
        { gmt: "GMT-10 (Гонолулу)", shift: -13 },
        { gmt: "GMT-9 (Анкоридж)", shift: -12 },
        { gmt: "GMT-8 (Лос-Анджелес)", shift: -11 },
        { gmt: "GMT-7 (Денвер)", shift: -10 },
        { gmt: "GMT-6 (Чикаго, Мехико)", shift: -9 },
        { gmt: "GMT-5 (Нью-Йорк, Богота)", shift: -8 },
        { gmt: "GMT-4 (Сантьяго, Каракас)", shift: -7 },
        { gmt: "GMT-3 (Буэнос-Айрес, Бразилиа)", shift: -6 },
        { gmt: "GMT-2 (Среднеатлантическое время)", shift: -5 },
        { gmt: "GMT-1 (Азорские острова)", shift: -4 },
        { gmt: "GMT±0 (Лондон, Дакар)", shift: -3 },
        { gmt: "GMT+1 (Париж, Берлин, Лагос)", shift: -2 },
        { gmt: "GMT+2 (Калининград, Афины, Каир)", shift: -1 },
        { gmt: "GMT+3 (Москва, Санкт-Петербург, Казань)", shift: 0 },
        { gmt: "GMT+4 (Самара, Волгоград, Дубай, Баку)", shift: 1 },
        { gmt: "GMT+5 (Екатеринбург, Уфа, Ташкент)", shift: 2 },
        { gmt: "GMT+6 (Омск, Челябинск, Алматы)", shift: 3 },
        { gmt: "GMT+7 (Новосибирск, Красноярск, Бангкок)", shift: 4 },
        { gmt: "GMT+8 (Иркутск, Улан-Удэ, Пекин)", shift: 5 },
        { gmt: "GMT+9 (Якутск, Чита, Токио, Сеул)", shift: 6 },
        { gmt: "GMT+10 (Владивосток, Хабаровск, Сидней)", shift: 7 },
        { gmt: "GMT+11 (Магадан, Сахалин)", shift: 8 },
        { gmt: "GMT+12 (Камчатка, Анадырь, Окленд)", shift: 9 },
        { gmt: "GMT+13 (Тонга, Апиа)", shift: 10 },
        { gmt: "GMT+14 (Лайн-Айлендс)", shift: 11 }
    ];

    const dayLabels = [
        ['Mon', 'Понедельник'],
        ['Tue', 'Вторник'],
        ['Wed', 'Среда'],
        ['Thu', 'Четверг'],
        ['Fri', 'Пятница'],
        ['Sat', 'Суббота'],
        ['Sun', 'Воскресенье']
    ];

    const generateTimeOptions = (start, end, suffix = '') => {
        const options = [];
        for (let i = start; i <= end; i++) {
            const label = i.toString().padStart(2, '0');
            options.push({ label, value: label + suffix });
        }
        return options;
    };

    const basicColumns = [
        generateTimeOptions(0, 23),
        [':'],
        generateTimeOptions(0, 59),
    ];

    const handleZoneChange = (event) => {
        const intValue = parseInt(event.target.value, 10);
        setTimezone(intValue)
    };

    const handleDeleteTimer = (timer) => {
        const [hours, minutes] = timer.split(':').map(Number);
        const newHours = (hours - timezone + 24) % 24;

        const timerToDelete = `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
        const updatedTimers = timers.filter(timer => timer !== timerToDelete);

        setTimers(updatedTimers);
    }

    const handleDaysChange = (event) => {
        const { checked, value } = event.target;

        setDays(prevDays => {
            if (checked) {
                // Если день выбран, добавляем его в список
                return [...prevDays, value];
            } else {
                // Если день не выбран, удаляем его из списка
                return prevDays.filter(day => day !== value);
            }
        });
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'timers') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        const hrElement = document.querySelector('.sectionChannelTimersList hr');
        if (hrElement) {
            if (timers && timers.length > 0) {
                hrElement.style.display = 'block';
            } else {
                hrElement.style.display = 'none';
            }
        }
    }, [timers]);

    useEffect(() => {
        const adjustTimeWithShift = (timers, timezone) => {
            return timers.map(timeString => {
                const [hours, minutes] = timeString.split(':').map(Number);
                const newHours = (hours + timezone + 24) % 24; // Добавляем 24 и используем модуль, чтобы избежать отрицательных значений
                return `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
            });
        };

        const updateAdjustedTags = adjustTimeWithShift(timers, timezone);
        setTimeZoneTimers(updateAdjustedTags);
    }, [timers, timezone])

    useEffect(() => {
        const saveTimers = async () => {
            const url = 'https://api.gmpapp.ru/save_timers';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, shift: timezone, days: days, timers: timers }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    const data = await response.json();
                    console.log('Success:', data);
                    
                    // Оптимистичное обновление локально
                    stream.timer = timers;
                    stream.shift = timezone;
                    stream.days = days;
                }
            } catch (error) {
                console.error('Error streams sending', error);
            }
        };

        saveTimers();
    }, [timezone, timers, days]);

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Picker
                    cancelText="Отменить"
                    confirmText="Добавить"
                    mouseWheel={true}
                    columns={basicColumns}
                    visible={timeVisible}
                    onClose={() => {
                        setTimeVisible(false)
                    }}
                    onConfirm={v => {
                        const adjustTimeWithShift = (shiftTimer) => {
                            const updatedTimers = new Set([...timers, shiftTimer]);
                            return Array.from(updatedTimers);
                        };

                        const shiftedTimer = (addTimer) => {
                            const [hours, minutes] = addTimer.split(':').map(Number);
                            const newHours = (hours - timezone + 24) % 24;

                            const timerToDelete = `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`

                            return timerToDelete;
                        }

                        const newTimer = v.join('');
                        const shiftTimer = shiftedTimer(newTimer);
                        const newTimers = adjustTimeWithShift(shiftTimer);
                        setTimers(newTimers);
                    }}
                />
                <Section className='sectionChannelTimers' header="Часовой пояс">
                    <Select onChange={handleZoneChange} defaultValue={timezone} header="Select" placeholder="Часовой пояс" name="timezone">
                        {timeZones.map((option) => (
                            <option key={option.shift} value={option.shift}>
                                {option.gmt}
                            </option>
                        ))}
                    </Select>
                </Section>
                <Section className='sectionChannelTimers sectionChannelTimersList' header='Таймеры'>
                    {timezoneTimers && timezoneTimers.length > 0 && (
                        <List className="timersList">
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: '0 10px' }}>
                                {timezoneTimers.map((timer, index) => (
                                    <Chip className='timerChip' key={index} after={<CancelIcon onClick={() => handleDeleteTimer(timer)} />}>
                                        {timer}
                                    </Chip>
                                ))}
                            </div>
                        </List>
                    )}
                    <ButtonCell onClick={() => { setTimeVisible(true) }} style={{ color: '#2688eb' }} before={<AddIcon />}>Добавить таймер</ButtonCell>
                </Section>
                <Section className='sectionChannelTimers' header='Дни недели'>
                    {dayLabels.map(([day, label]) => (
                        <Cell key={day} Component="label" before={<Multiselectable onChange={handleDaysChange} defaultChecked={days.includes(day)} name="multiselect" value={day} />}>{label}</Cell>
                    ))}
                </Section>
            </AppRoot>
        </div>
    );
};

export default TimersPage;